import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { CommunicationModel } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  constructor(private ajax: CustomAjax) { }

  public SendSMS(communicationModel: CommunicationModel, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Communication/SendSMS", communicationModel,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public SendEmail(communicationModel: CommunicationModel, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Communication/SendEmail", communicationModel,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

}
